"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETHTransactionType = void 0;
exports.describeETHPath = describeETHPath;
exports.buildMessage = buildMessage;
const ethers_1 = require("ethers");
const utils_1 = require("./utils");
var ETHTransactionType;
(function (ETHTransactionType) {
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_LEGACY"] = 0] = "ETH_TX_TYPE_LEGACY";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_2930"] = 1] = "ETH_TX_TYPE_EIP_2930";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_1559"] = 2] = "ETH_TX_TYPE_EIP_1559";
})(ETHTransactionType || (exports.ETHTransactionType = ETHTransactionType = {}));
function describeETHPath(path) {
    const pathStr = (0, utils_1.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Ethereum",
        isKnown: false,
    };
    if (path.length !== 5)
        return unknown;
    if (path[0] !== 0x80000000 + 44)
        return unknown;
    if (path[1] !== 0x80000000 + (0, utils_1.slip44ByCoin)("Ethereum"))
        return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    if (path[3] !== 0)
        return unknown;
    if (path[4] !== 0)
        return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Ethereum Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Ethereum",
        isKnown: true,
        isPrefork: false,
    };
}
function buildMessage(message) {
    const messageBytes = typeof message === "string" && !ethers_1.ethers.utils.isHexString(message)
        ? ethers_1.ethers.utils.toUtf8Bytes(message)
        : ethers_1.ethers.utils.arrayify(message);
    return ethers_1.ethers.utils.concat([
        ethers_1.ethers.utils.toUtf8Bytes("\x19Ethereum Signed Message:\n"),
        ethers_1.ethers.utils.toUtf8Bytes(String(messageBytes.length)),
        messageBytes,
    ]);
}
//# sourceMappingURL=ethereum.js.map